<template>
  <div class="notification error-msg">
    <p>{{ title }}</p>
    <p>{{ msg }}</p>
  </div>
</template>

<script>
export default {
  props: ['msg', 'title'],
  name: "Incorrect"
}
</script>

<style scoped>

</style>